export const ShippingCompanyServiceLevelMapper = {
  Terceiro: 'Terceiro',
  'Agregado Ouro': 'Ouro',
  Agregado: 'Agregado',
};
